import React, { Dispatch, useMemo } from 'react';
import classes from './PostContentFilterGroup.module.scss';
import { PostScheduleFilterAction } from '../../../models/post';
import { PostScheduleViewContext } from '../../../modules/Publish/PostSchedule/PostSchedule.controller';
import { FilterItemGroup } from '../FilterItemGroup';
import { FilterItem } from '../FilterItem';
import { PostQueueCountResult, QueueFilterPostContent } from '../../../models/graphql';
import { PostScheduleHelpers } from '../../../modules/Publish/PostSchedule/postScheduleHelpers';

export type PostContentFilterGroupViewProps = {
  loading: boolean;
  dispatchFilters: Dispatch<PostScheduleFilterAction>;
  activeFilterId?: string;
  context: PostScheduleViewContext;
  queueCounts: PostQueueCountResult;
};

export const PostContentFilterGroupView = (props: PostContentFilterGroupViewProps): JSX.Element => {
  const { queueCounts } = props; // useContext(QueueCountContext);
  const setSelectedFilter = (id: string) => {
    props.dispatchFilters({ type: 'content', payload: { data: id, fetchPosts: true } });
  };

  const counts = useMemo(() => PostScheduleHelpers.getQueueCounts(queueCounts, 'content'), [queueCounts]);

  return (
    <FilterItemGroup title={'Filter By Content'}>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostContent.IMAGE}
        count={counts.image}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostContent.IMAGE)}>
        <div className={classes.Label}>Image</div>
      </FilterItem>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostContent.IMAGE_LINK}
        count={counts.imageLink}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostContent.IMAGE_LINK)}>
        <div className={classes.Label}>Image + Link</div>
      </FilterItem>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostContent.LINK}
        count={counts.link}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostContent.LINK)}>
        <div className={classes.Label}>Link</div>
      </FilterItem>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostContent.TEXT}
        count={counts.text}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostContent.TEXT)}>
        <div className={classes.Label}>Text</div>
      </FilterItem>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostContent.VIDEO}
        count={counts.video}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostContent.VIDEO)}>
        <div className={classes.Label}>Video</div>
      </FilterItem>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostContent.VIDEO_LINK}
        count={counts.videoLink}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostContent.VIDEO_LINK)}>
        <div className={classes.Label}>Video + Link</div>
      </FilterItem>
    </FilterItemGroup>
  );
};
